const SHORT = ["Jän", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"];

/** Axis maximum: the next clean value (1, 1.5, 2, 2.5, 3, 4, 5, 6, 8 × 10^k) at or above `v` (min 100). */
export function niceMax(v: number): number {
  if (v <= 100) return 100;
  const mag = 10 ** Math.floor(Math.log10(v));
  for (const f of [1, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10]) if (f * mag >= v) return f * mag;
  return 10 * mag;
}

/** Evenly spaced clean ticks from 0 to `max` (max comes from niceMax). */
export function ticks(max: number): number[] {
  const mag = 10 ** Math.floor(Math.log10(max));
  // Largest clean step that still yields at least three intervals and divides the axis evenly.
  const step = [mag * 5, mag * 2, mag, mag / 2, mag / 4].find((s) => max / s >= 3 && Number.isInteger(max / s)) ?? max / 4;
  return Array.from({ length: Math.round(max / step) + 1 }, (_, i) => i * step);
}

export function monthShort(ym: string): string {
  return SHORT[Number(ym.slice(5, 7)) - 1] ?? ym;
}

/** Percent change from `prev` to `cur`, rounded; null when there is no base to compare with. */
export function deltaPct(cur: number, prev: number): number | null {
  return prev > 0 ? Math.round(((cur - prev) / prev) * 100) : null;
}

export function daysBetween(from: string, to: string): number {
  return Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / 86_400_000);
}
